module.exports = __webpack_public_path__ + "static/img/eyeware.bc6e83b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/marketplace/eyeware.png
// module id = 8+D+
// module chunks = 1